"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.monadtest = void 0;
exports.monadtest = {
    "addresses": {
        "ProxyAdmin": "0x91E61a73e021D701092Abf8f0C2036c4B9711AE7",
        "Multicall2": "0xa52A889FCA8706EB91Df92421E4303550aDfb64D",
        "Sumer": "0xC7e7987d4C891c355b1b3D684795354Cd2631E1E",
        "CompoundLens": "0x092fa73f599f3CcEa2093d65c9fDcb4A49fa7924",
        "FeedPriceOracle": "0x56095A966542FBEE6181EA1eD24c44399da23a3F",
        "CompLogic": "0xc53fCf3cE027ABbb7fAaAB77eFa464eD67EE1f6f",
        "RedemptionManager": "0x9A00A29732DDC6EE4CE8Ca115e0ba155cD34Cb28",
        "Timelock": "0x18438738298064D48666CF52Ad7A759d2d838f97",
        "Comptroller": "0x32F1C06EB41BF76dfd4C3E4F73BEfeBCAEc60D13",
        "sdrMON": "0xd813695790F6224DbefF433414cc0882A1159f3f",
        "MON": "0x0000000000000000000000000000000000000000",
        "CErc20": "0xf1Af26dbA632a492c38fAcCdb0588f638a505f3C",
        "suErc20": "0xCCceD2C747f0a2Ef83B194d21d653a1E2b3D95f6",
        "JumpRate#1": "0xAd0f0eB54624EaC77aEEd89A237849f2e608C7a7",
        "ZeroRate": "0x3e546b90aB430a0101177b42A605f96eEED6De08",
        "sdrUSDC": "0x25b13e42763a97dd4041f595220642B593962356",
        "USDC": "0xf817257fed379853cDe0fa4F97AB987181B1E5Ea",
        "sdrUSDT": "0x4a997f2B619e7c7F4f7C2621b9Fa44CD616941E1",
        "USDT": "0x88b8E2161DEDC77EF4ab7585569D2415a1C1055D",
        "sdrWBTC": "0x64A9b3e30f9E4A45AB6137d9C0B12AE2bA8DC251",
        "WBTC": "0xcf5a6076cfa32686c0Df13aBaDa2b40dec133F1d",
        "sdrFiaBTC": "0xE10b5F5B54eB544f68EFA073Fb6e9Ad16Cbf8bD0",
        "FiaBTC": "0x859fb36f3Fe7e22b37dd99b501f891377DdC9c33",
        "sdrWETH": "0xEB441902ac56ae1340E178fBCcb3Ce5890206FcA",
        "WETH": "0xB5a30b0FDc5EA94A52fDc42e3E9760Cb8449Fb37",
        "sdrsuUSD": "0x2AB1Fba9C45237502A561576BB89137Ce1f9D279",
        "suUSD": "0x8F3A8ae1f1859636E82CA4e30DB9FB129B02d825",
        "sdrsuETH": "0x06C6764BA4E2fBbA5130f4B87a413831fCdB6b0a",
        "suETH": "0x3247B7d8100556ce6fC1A4141c117104ef806850",
        "sdrsuBTC": "0x8323fd1a8fF11F690A17724FBf9E8f5b4e802aF4",
        "suBTC": "0x4961c832469Fcbb468c0a794de32FAaa30ccD2F6",
        "sdraprMON": "0x7DD4461FC2E0539596E4B9fFEF10C7748C2b8791",
        "aprMON": "0xb2f82D0f38dc453D596Ad40A37799446Cc89274A",
        "aprMONAdapter": "0xd7b93058Ba754a1924277CE99602051716d9bE37",
        "sdrsMON": "0x7181fBab419D5e45C07EB11d88Cd2C3230649FB8",
        "sMON": "0xe1d2439b75fb9746E7Bc6cB777Ae10AA7f7ef9c5",
        "sdrgMON": "0x229E77fC7Cf9a3e5cE79eE98989853C99e0FD225",
        "gMON": "0xaEef2f6B429Cb59C9B2D7bB2141ADa993E8571c3"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdrUSDC",
            "ctokenAddr": "0x25b13e42763a97dd4041f595220642B593962356",
            "underlySym": "USDC",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xf817257fed379853cDe0fa4F97AB987181B1E5Ea",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrUSDT",
            "ctokenAddr": "0x4a997f2B619e7c7F4f7C2621b9Fa44CD616941E1",
            "underlySym": "USDT",
            "ctokenDecimal": 6,
            "underlyDecimal": 6,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x88b8E2161DEDC77EF4ab7585569D2415a1C1055D",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrWBTC",
            "ctokenAddr": "0x64A9b3e30f9E4A45AB6137d9C0B12AE2bA8DC251",
            "underlySym": "WBTC",
            "ctokenDecimal": 8,
            "underlyDecimal": 8,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xcf5a6076cfa32686c0Df13aBaDa2b40dec133F1d",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrFiaBTC",
            "ctokenAddr": "0xE10b5F5B54eB544f68EFA073Fb6e9Ad16Cbf8bD0",
            "underlySym": "FiaBTC",
            "ctokenDecimal": 8,
            "underlyDecimal": 8,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x859fb36f3Fe7e22b37dd99b501f891377DdC9c33",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrWETH",
            "ctokenAddr": "0xEB441902ac56ae1340E178fBCcb3Ce5890206FcA",
            "underlySym": "WETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xB5a30b0FDc5EA94A52fDc42e3E9760Cb8449Fb37",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrsuUSD",
            "ctokenAddr": "0x2AB1Fba9C45237502A561576BB89137Ce1f9D279",
            "underlySym": "suUSD",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x8F3A8ae1f1859636E82CA4e30DB9FB129B02d825",
            "assetGroupId": 1
        },
        {
            "ctokenSym": "sdrsuETH",
            "ctokenAddr": "0x06C6764BA4E2fBbA5130f4B87a413831fCdB6b0a",
            "underlySym": "suETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x3247B7d8100556ce6fC1A4141c117104ef806850",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrsuBTC",
            "ctokenAddr": "0x8323fd1a8fF11F690A17724FBf9E8f5b4e802aF4",
            "underlySym": "suBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x4961c832469Fcbb468c0a794de32FAaa30ccD2F6",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdraprMON",
            "ctokenAddr": "0x7DD4461FC2E0539596E4B9fFEF10C7748C2b8791",
            "underlySym": "aprMON",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xb2f82D0f38dc453D596Ad40A37799446Cc89274A",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdrsMON",
            "ctokenAddr": "0x7181fBab419D5e45C07EB11d88Cd2C3230649FB8",
            "underlySym": "sMON",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xe1d2439b75fb9746E7Bc6cB777Ae10AA7f7ef9c5",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdrgMON",
            "ctokenAddr": "0x229E77fC7Cf9a3e5cE79eE98989853C99e0FD225",
            "underlySym": "gMON",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xaEef2f6B429Cb59C9B2D7bB2141ADa993E8571c3",
            "assetGroupId": 4
        },
        {
            "ctokenSym": "sdrMON",
            "ctokenAddr": "0xd813695790F6224DbefF433414cc0882A1159f3f",
            "underlySym": "MON",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": true,
            "permitEnabled": false,
            "underlyAddr": "0x0000000000000000000000000000000000000000"
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#1",
            "contract": "JumpRateModelV2",
            "address": "0xAd0f0eB54624EaC77aEEd89A237849f2e608C7a7",
            "tokens": [
                "MON",
                "USDC",
                "USDT",
                "WBTC",
                "FiaBTC",
                "WETH",
                "sMON",
                "gMON",
                "MON"
            ],
            "baseRatePerYear": "0",
            "multiplierPerYear": "0.1",
            "jumpMultiplierPerYear": "3",
            "kink": "0.65"
        },
        {
            "name": "ZeroRate",
            "contract": "FixedInterestRateModel",
            "address": "0x3e546b90aB430a0101177b42A605f96eEED6De08",
            "tokens": [
                "suUSD",
                "suETH",
                "suBTC",
                "aprMON"
            ],
            "initBorrowRate": "0",
            "initSupplyRate": "0"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=monadtest.js.map